/**
 * Embed kodları oluşturmak ve yönetmek için yardımcı fonksiyonlar
 */


/**
 * Embed kodunu kullanıcıya göstermek için modal açar
 * @param {string} embedCode - Gösterilecek embed kodu
 * @param {Object} options - Embed seçenekleri (width, height, h, ts)
 * @returns {Promise<boolean>} İşlemin başarılı olup olmadığı
 */
export const showEmbedModal = (embedCode, options = {}) => {
  return new Promise((resolve) => {
    // Modal içeriğini oluştur
    const modalContainer = document.createElement('div');
    modalContainer.className = 'fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50';
    modalContainer.style.backdropFilter = 'blur(3px)';
    
    // Modal içeriği
    const modalContent = document.createElement('div');
    modalContent.className = 'bg-white rounded-lg shadow-xl p-6 w-full max-w-lg mx-4';
    
    // Başlık
    const title = document.createElement('h3');
    title.className = 'text-xl font-bold text-gray-800 mb-4';
    title.textContent = 'Embed Kodu';
    
    // Açıklama
    const description = document.createElement('p');
    description.className = 'text-gray-600 mb-4';
    description.textContent = 'Bu kodu web sitenize veya blogunuza ekleyerek bu etkinliği gömebilirsiniz. Bu kod doğrudan herhangi bir web sayfasında çalışacak şekilde tasarlanmıştır.';
    
    // Özelleştirme seçenekleri
    const customizationTitle = document.createElement('h4');
    customizationTitle.className = 'text-md font-semibold text-gray-800 mt-6 mb-2';
    customizationTitle.textContent = 'Özelleştirme Seçenekleri:';
    
    // Özelleştirme formu
    const form = document.createElement('div');
    form.className = 'grid grid-cols-2 gap-4 mb-4';
    
    // Width input
    const widthGroup = document.createElement('div');
    widthGroup.className = 'flex flex-col';
    const widthLabel = document.createElement('label');
    widthLabel.className = 'text-sm text-gray-600 mb-1';
    widthLabel.textContent = 'Genişlik:';
    const widthInput = document.createElement('input');
    widthInput.type = 'text';
    widthInput.className = 'border border-gray-300 rounded-md p-2 text-sm';
    widthInput.value = options.width || '100%';
    widthInput.placeholder = 'Örn: 100% veya 800px';
    widthGroup.appendChild(widthLabel);
    widthGroup.appendChild(widthInput);
    
    // Height input
    const heightGroup = document.createElement('div');
    heightGroup.className = 'flex flex-col';
    const heightLabel = document.createElement('label');
    heightLabel.className = 'text-sm text-gray-600 mb-1';
    heightLabel.textContent = 'Yükseklik:';
    const heightInput = document.createElement('input');
    heightInput.type = 'number';
    heightInput.className = 'border border-gray-300 rounded-md p-2 text-sm';
    heightInput.value = options.height || '650px';
    heightInput.placeholder = 'Örn: 650px';
    heightGroup.appendChild(heightLabel);
    heightGroup.appendChild(heightInput);
    
    // Inner height (h) input
    const hGroup = document.createElement('div');
    hGroup.className = 'flex flex-col';
    const hLabel = document.createElement('label');
    hLabel.className = 'text-sm text-gray-600 mb-1';
    hLabel.textContent = 'İç Yükseklik (h):';
    const hInput = document.createElement('input');
    hInput.type = 'number';
    hInput.className = 'border border-gray-300 rounded-md p-2 text-sm';
    hInput.value = options.h || '700';
    hInput.placeholder = 'Örn: 700';
    hGroup.appendChild(hLabel);
    hGroup.appendChild(hInput);
    
    // Time skip (ts) input
    const tsGroup = document.createElement('div');
    tsGroup.className = 'flex flex-col';
    const tsLabel = document.createElement('label');
    tsLabel.className = 'text-sm text-gray-600 mb-1';
    tsLabel.textContent = 'Zaman Atlama (ts):';
    const tsInput = document.createElement('input');
    tsInput.type = 'number';
    tsInput.className = 'border border-gray-300 rounded-md p-2 text-sm';
    tsInput.value = options.ts || '100';
    tsInput.placeholder = 'Örn: 100';
    tsGroup.appendChild(tsLabel);
    tsGroup.appendChild(tsInput);
    
    // Add all inputs to form
    form.appendChild(widthGroup);
    form.appendChild(heightGroup);
    form.appendChild(hGroup);
    form.appendChild(tsGroup);
    
    // Kod alanı
    const codeArea = document.createElement('div');
    codeArea.className = 'relative';
    
    const textarea = document.createElement('textarea');
    textarea.className = 'w-full h-32 p-3 border border-gray-300 rounded-md font-mono text-sm bg-gray-50';
    textarea.readOnly = true;
    textarea.value = embedCode;
    
    // Kopyalama butonu
    const copyButton = document.createElement('button');
    copyButton.className = 'absolute top-2 right-2 bg-blue-500 hover:bg-blue-600 text-white px-3 py-1 rounded-md text-sm font-medium transition-colors';
    copyButton.textContent = 'Kopyala';
    copyButton.onclick = () => {
      textarea.select();
      document.execCommand('copy');
      copyButton.textContent = 'Kopyalandı!';
      copyButton.className = 'absolute top-2 right-2 bg-green-500 hover:bg-green-600 text-white px-3 py-1 rounded-md text-sm font-medium transition-colors';
      setTimeout(() => {
        copyButton.textContent = 'Kopyala';
        copyButton.className = 'absolute top-2 right-2 bg-blue-500 hover:bg-blue-600 text-white px-3 py-1 rounded-md text-sm font-medium transition-colors';
      }, 2000);
    };
    
    // Önizleme ekliyoruz - yeni
    const previewTitle = document.createElement('h4');
    previewTitle.className = 'text-md font-semibold text-gray-800 mt-6 mb-2';
    previewTitle.textContent = 'Önizleme:';
    
    const previewArea = document.createElement('div');
    previewArea.className = 'border border-gray-300 rounded-md p-2 overflow-auto max-h-64';
    previewArea.innerHTML = embedCode;
    
    // Kapatma butonu
    const closeButton = document.createElement('button');
    closeButton.className = 'mt-4 w-full bg-gray-200 hover:bg-gray-300 text-gray-800 font-medium py-2 px-4 rounded-md transition-colors';
    closeButton.textContent = 'Kapat';
    closeButton.onclick = () => {
      document.body.removeChild(modalContainer);
      resolve(true);
    };
    
    // Elemanları birleştir
    codeArea.appendChild(textarea);
    codeArea.appendChild(copyButton);
    
    modalContent.appendChild(title);
    modalContent.appendChild(description);
    modalContent.appendChild(customizationTitle);
    modalContent.appendChild(form);
    modalContent.appendChild(codeArea);
    modalContent.appendChild(previewTitle);
    modalContent.appendChild(previewArea);
    modalContent.appendChild(closeButton);
    
    modalContainer.appendChild(modalContent);
    
    // Modalı ekle
    document.body.appendChild(modalContainer);
    
    // Textarea'yı seç
    textarea.focus();
    textarea.select();
  });
};


/**
 * Tüm zaman çizelgesi uygulamasını iframe olarak gösterecek embed kodu oluşturur
 * @param {Object} timeline - Timeline verisi
 * @param {string} baseUrl - Uygulamanın temel URL'i (varsayılan olarak mevcut site)
 * @param {Object} options - Embed seçenekleri (width, height, h, ts)
 * @returns {string} Oluşturulan iframe embed kodu
 */
export const generateFullTimelineIframeCode = (timeline, baseUrl = window.location.origin, options = {}) => {
  if (!timeline || !timeline._id) {
    return '';
  }

  // Timeline bilgilerini güvenli şekilde al
  const title = timeline.title || 'İsimsiz Zaman Çizelgesi';
  const timelineId = timeline._id;
  
  // Default values
  const defaultWidth = '100%';
  const defaultHeight = '650px';
  const defaultInnerHeight = '700';
  const defaultTimeSkip = timeline.timeSkip || '100';
  
  // Get options with defaults
  const width = options.width || defaultWidth;
  const height = options.height || defaultHeight;
  const innerHeight = options.h || defaultInnerHeight;
  const timeSkip = options.ts || defaultTimeSkip;
  
  // Build URL with parameters
  const timelineUrl = `${baseUrl}/timeline/${timelineId}?h=${innerHeight}&ts=${timeSkip}`;
  
  // Timeline iframe embed kodu
  const embedCode = `<!-- Timeline Full App Embed - ${title} -->
<div style="width:${width}; font-family:Arial, sans-serif;">
  <style>
    .timeline-full-embed {
      width: 100%;
      overflow: hidden;
      border-radius: 8px;
      box-shadow: 0 2px 10px rgba(0,0,0,0.1);
      border: 1px solid #e5e5e5;
      position: relative;
    }
    .timeline-full-iframe {
      width: 100%;
      height: ${height};
      border: none;
    }
    .timeline-full-footer {
      position: absolute;
      top: 15px;
      right: 20px;
      padding: 12px 16px;
      font-size: 16px;
      color: white;
      background: rgba(0, 0, 0, 0.6);
      border-radius: 8px;
      z-index: 10;
      cursor: pointer;
      display: flex;
      align-items: center;
      gap: 8px;
      transition: all 0.3s ease;
    }
    .timeline-full-footer:hover {
      background: rgba(0, 0, 0, 0.8);
      transform: scale(1.08);
    }
    .timeline-full-footer svg {
      width: 24px;
      height: 24px;
    }
    @media (max-width: 768px) {
      .timeline-full-iframe {
        height: 500px;
      }
    }
  </style>
  <div class="timeline-full-embed">
    <div class="timeline-full-footer" onclick="window.open('${baseUrl}/timeline/${timelineId}', '_blank')">
      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
        <path d="M1.5 1a.5.5 0 0 0-.5.5v4a.5.5 0 0 1-1 0v-4A1.5 1.5 0 0 1 1.5 0h4a.5.5 0 0 1 0 1h-4zM10 .5a.5.5 0 0 1 .5-.5h4A1.5 1.5 0 0 1 16 1.5v4a.5.5 0 0 1-1 0v-4a.5.5 0 0 0-.5-.5h-4a.5.5 0 0 1-.5-.5zM.5 10a.5.5 0 0 1 .5.5v4a.5.5 0 0 0 .5.5h4a.5.5 0 0 1 0 1h-4A1.5 1.5 0 0 1 0 14.5v-4a.5.5 0 0 1 .5-.5zm15 0a.5.5 0 0 1 .5.5v4a1.5 1.5 0 0 1-1.5 1.5h-4a.5.5 0 0 1 0-1h4a.5.5 0 0 0 .5-.5v-4a.5.5 0 0 1 .5-.5z"/>
      </svg>
    </div>
    <iframe 
      class="timeline-full-iframe" 
      src="${timelineUrl}" 
      title="${title}" 
      allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" 
      allowfullscreen>
    </iframe>
  </div>
</div>
<!-- Timeline Full App Embed Son -->`;

  return embedCode;
};



export default {
  showEmbedModal,
  generateFullTimelineIframeCode,
}; 